export const MODAL_FRAMES = new Set(['modal', 'modal-inner', 'drawer-modal', 'modal-inner-stacked', 'overlay-drawer']);

export function localPath(value, origin) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || /[\\\s]/.test(value))
    return null;
  try {
    const url = new URL(value, origin);
    return url.origin === origin ? `${url.pathname}${url.search}${url.hash}` : null;
  } catch {
    return null;
  }
}

export function modalLocation(href) {
  const url = new URL(href);
  const encoded = url.searchParams.get('modal');
  url.searchParams.delete('modal');
  const dialogs = [];
  try {
    const entries = JSON.parse(encoded);
    if (Array.isArray(entries) && entries.length <= 8) {
      for (const entry of entries) {
        const path = localPath(entry?.url, url.origin);
        if (!path || !MODAL_FRAMES.has(entry.frame) || dialogs.some((dialog) => dialog.frame === entry.frame)) break;
        dialogs.push({ frame: entry.frame, url: path });
      }
    }
  } catch {
    /* A malformed link still opens its underlying page. */
  }
  return { base: url.href, dialogs };
}

export function modalURL(base, dialogs) {
  const url = new URL(base);
  url.searchParams.delete('modal');
  if (dialogs.length) url.searchParams.set('modal', JSON.stringify(dialogs.map(({ frame, url }) => ({ frame, url }))));
  return url;
}

export function sameDialog(left, right) {
  return left?.url === right?.url && left?.frame === right?.frame;
}

// Isolate the pinned Turbo 8 history API. Never push empty state: Turbo and
// discard guards both need a unique restoration identifier and history index.
export class ModalHistory {
  constructor(turbo) {
    this.turbo = turbo;
  }

  intercept(listener) {
    // Window-targeted popstate listeners execute in registration order. Register
    // before Turbo so it cannot start a restoration visit while a close is vetoed.
    const history = this.turbo.session.history;
    window.removeEventListener('popstate', history.onPopState);
    window.addEventListener('popstate', listener, true);
    window.addEventListener('popstate', history.onPopState);
  }

  write(url, action = 'push', parent = null) {
    const history = this.turbo.session.history;
    const parentIndex = history.currentIndex;
    history[action](url);
    window.history.replaceState({ ...window.history.state, modalNavigation: { parent, parentIndex } }, '', url);
    this.turbo.session.view.lastRenderedLocation = url;
  }

  adopt(url, state) {
    const history = this.turbo.session.history;
    history.location = url;
    history.restorationIdentifier = state.turbo.restorationIdentifier;
    history.currentIndex = state.turbo.restorationIndex;
    this.turbo.session.view.lastRenderedLocation = url;
  }
}
